// Перший екран проходження квіза

import beerHero from "../../assets/quiz/beer-hero.png"; // 🔥 правильний шлях

export default function BeerFinderStartScreen({ t, onStart }) {
  return (
    <div className="beerFinder">
      <div className="beerFinderCard beerFinderStart">

        <div className="beerFinderHero">
          <img src={beerHero} alt="Beer" />
        </div>

        <div className="beerFinderContent">
          <h2>{t("start_title")}</h2>

          <p>{t("start_subtitle")}</p>

          <button
            className="beerFinderPrimaryBtn"
            type="button"
            onClick={onStart}
          >
            {t("start_cta")}
          </button>
        </div>

      </div>
    </div>
  );
}